import tw from "twin.macro"
import Icon from "../../atoms/Icon"
import { Pill } from "../../atoms/Pill"
import React, { useContext } from "react"
import { LanguageContext } from "../../../contexts/Language"
import { FiltersState } from "../../../contexts/Filters/filters.d"

const FilterModalResultsCta = ({
  state,
  dealers,
  setInventoryResults,
  dispatchFilters,
  closeFiltersModal,
  filtersState,
  dispatch,
  setQueryFromFilters,
  setRefineInAction,
  sortedFilter,
  inventoryFilters,
  swipeScrollMessageVisible,
}: {
  state: any
  dealers: any
  setInventoryResults: (results: any) => void
  dispatchFilters: (action: any) => void
  closeFiltersModal: any
  filtersState: any
  dispatch: (action: any) => void
  setQueryFromFilters: (
    selectedFilters: FiltersState["selectedFilters"],
    currentDealerFilter: any,
    dealerCodes: string,
  ) => any
  setRefineInAction: (action: {
    inProgress: boolean
    tealiumEvent: string
    couponModuleText: string
    filtersQueue: any
    filterValues: any
  }) => void
  sortedFilter: any
  inventoryFilters: any
  swipeScrollMessageVisible: boolean
}) => {
  const { _ } = useContext(LanguageContext)

  const handleSave = () => {
    // if the location or radius is changed in the modal, reset the inventory search results
    if (dealers && dealers?.length < state.dealer.split(",").length) {
      setInventoryResults && setInventoryResults(null)
    }
    //close modal
    dispatchFilters(closeFiltersModal())
    //update inventory query
    const allDealers = dealers
      ?.map((dealer: { DealerCode: string }) => dealer.DealerCode)
      .join(",")
    const { radius, ...remainingSelectedFilters } = filtersState.selectedFilters
    dispatch(
      setQueryFromFilters(
        remainingSelectedFilters,
        filtersState?.currentDealerFilter!,
        allDealers!,
      ),
    )
    //trigger tealium refinement event that fires save event and passes filters to fire on inventory results load
    setRefineInAction({
      inProgress: true,
      tealiumEvent: "cta_click",
      couponModuleText: "Save",
      filtersQueue: inventoryFilters,
      filterValues: sortedFilter.remainingFilters,
    })
  }

  return (
    <div
      css={[
        tw`sticky bottom-0 w-full bg-white flex flex-col items-center justify-end border-t-gray-200 border-t z-50`,
        tw`md:(rounded-bl-2xl rounded-br-2xl)`,
      ]}
    >
      <span
        css={[
          tw`h-[4rem] border-t-gray-200 py-2 bg-white flex flex-col items-center justify-center gap-2 w-full`,
        ]}
      >
        {swipeScrollMessageVisible && (
          <React.Fragment>
            <h5 css={[tw`font-semibold text-center`]}>
              <span css={[tw`hidden lg:inline`]}>
                {_("Scroll down for More Filters")}
              </span>
              <span css={[tw`inline lg:hidden`]}>
                {_("Swipe for More Filters")}
              </span>
            </h5>

            <Icon.Chevron direction="down" css={[tw`w-4`]} />
          </React.Fragment>
        )}
      </span>

      <div
        css={[
          tw`h-full py-3 bg-gray-100 w-full flex justify-center`,
          tw`md:(rounded-bl-2xl rounded-br-2xl)`,
        ]}
      >
        <Pill
          onClick={handleSave}
          analytics-id={"save:filter modal:"}
          css={[
            tw`text-center! uppercase w-full bg-red-400 rounded-full w-full font-semibold py-2 max-w-[400px] mx-auto overflow-visible! text-white md:mx-auto`,
          ]}
          alignment={"center"}
        >
          {_("See Results")}
        </Pill>
      </div>
    </div>
  )
}

export default FilterModalResultsCta
